<template>
  <v-list nav dense>
    <v-list-item-group>
      <the-drawer-locale />
    </v-list-item-group>
    <v-divider class="ma-1" />
    <v-list-item-group>
      <base-drawer-menu-item
        :icon="mdiViewDashboard"
        :title="$t('titles.dashboard')"
        :to="{ name: ROUTES.NAME.HOME }"
      />
      <base-drawer-menu-item
        :icon="mdiAccountMultiple"
        :title="$t('titles.validators')"
        :to="{ name: ROUTES.NAME.VALIDATORS }"
      />
      <base-drawer-menu-item
        :icon="mdiSwapHorizontalBold"
        :title="$t('titles.transactions')"
        :to="{ name: ROUTES.NAME.TRANSACTIONS }"
      />
      <base-drawer-menu-item
        :icon="mdiShape"
        :title="$t('titles.blocks')"
        :to="{ name: ROUTES.NAME.BLOCKS }"
      />
      <base-drawer-menu-item
        :icon="mdiLibrary"
        :title="$t('titles.assets')"
        :to="{ name: ROUTES.NAME.ASSETS }"
      />
      <base-drawer-menu-link
        :icon="mdiBookOpenPageVariant"
        title="Ledger Documentation"
        :href="`${docsBaseUrl}/docs`"
      />
      <base-drawer-menu-link
        :icon="mdiXml"
        title="Platform API"
        :href="`${docsBaseUrl}/docs-platform`"
      />
    </v-list-item-group>
    <v-divider class="ma-1" />
    <v-list-item-group>
      <the-drawer-social-medial />
      <the-drawer-theme-switcher />
    </v-list-item-group>
  </v-list>
</template>

<script>
import BaseDrawerMenuItem from './BaseDrawerMenuItem';
import BaseDrawerMenuLink from './BaseDrawerMenuLink';
import TheDrawerLocale from './TheDrawerLocale';
import TheDrawerSocialMedial from './TheDrawerSocialMedial';
import TheDrawerThemeSwitcher from './TheDrawerThemeSwitcher';

import { ROUTES } from '@/constants';
import {
  mdiAccountMultiple,
  mdiBookOpenPageVariant,
  mdiLibrary,
  mdiShape,
  mdiSwapHorizontalBold,
  mdiViewDashboard,
  mdiXml,
} from '@mdi/js';

export default {
  name: 'TheDrawer',
  components: {
    BaseDrawerMenuItem,
    BaseDrawerMenuLink,
    TheDrawerLocale,
    TheDrawerSocialMedial,
    TheDrawerThemeSwitcher,
  },
  data() {
    return {
      ROUTES,
      mdiAccountMultiple,
      mdiBookOpenPageVariant,
      mdiLibrary,
      mdiShape,
      mdiSwapHorizontalBold,
      mdiViewDashboard,
      mdiXml,
    };
  },
  computed: {
    docsBaseUrl() {
      return window.location.origin;
    },
  },
};
</script>
